import { useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { getCity, listCitiesByState } from './Cities.service';
import { queryClient } from '@/Root';

export function useCitiesByState(state?: string, enabled = true) {
  const cache = queryClient.getQueryData(['cities', 'state', state]);

  const query = useQuery(
    ['cities', 'state', state],
    () => (state ? listCitiesByState(state) : undefined),
    { enabled: enabled && !!state && !cache },
  );

  useServiceError(query.error);

  return query;
}

export function useCity(id?: number, enabled = true) {
  const cache = queryClient.getQueryData(['cities', id]);

  const query = useQuery(['cities', id], () => (id ? getCity(id) : undefined), {
    enabled: enabled && !!id && !cache,
  });

  useServiceError(query.error);

  return query;
}

export function useCityMutation() {
  const query = useMutation((id: number) => getCity(id));

  useServiceError(query.error);

  return query;
}
